import services from "../services";
// Totp store to make sure the data are not persistant like it is on auth
const strict = true;
const getDefaultState = () => {
	return {
		nonce:'',
		email:'',
		secret:''
	}
}
const state = getDefaultState();

const getters = {
	getNonce: (state) => state.nonce.value,
	getEmail: (state) => state.email,
	getSecret:(state) => state.secret
}

const mutations = {
	RESET(state) {
		const s = getDefaultState();
		Object.keys(s).forEach((key) => {
			state[key] = s[key];
		});
	},
	SET_NONCE(state, nonce) {
		state.nonce = nonce;
	},
	SET_EMAIL(state, email) {
		state.email = email;
	},
	SET_SECRET(state,secret){
		state.secret = secret;
	}
}

const actions = {
	validateUserTotpAndLogin({getters},totp) {
		const payload = {
			totp: totp.totp,
			email: getters.getEmail,
			nonce: getters.getNonce
		}
		return services.UserService.validateUserTotpAndLogin(payload)
			.then((response) => response)
			.catch((error) => {
				console.error('Error while verifyTOTP: ', error)
				return Promise.reject(error);
			});
	},

	generateTOTP() {

	}
}

export default {
	namespaced: true,
	strict,
	state,
	getters,
	actions,
	mutations
}